import { useEffect, useState } from 'react';

/**
 * returns admin HTML Login page content
 */
export function useLandingPageContent() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    async function getAdminHtmlContent() {
      try {
        const response = await fetch(
          `${process.env.MIX_ADMIN_SYSTEM_URL}/api/landing-page-content`,
          {
            headers: { 'Content-Type': 'application/json' },
            method: 'GET',
          },
        );

        const payload = await response.json();
        setContent(payload.content);
      } catch (error) {
        console.info(
          'Error while retrieving login page HTML content (Admin system)',
        );
        console.error(error);
      }
    }
    getAdminHtmlContent();
  }, []);

  return content;
}
